import React from 'react';

import {StyledCompactItemHeaderSpan} from 'app/general/bootstrap/utils';
import {BreadcrumbItemStructure} from 'app/general/structures/BreadcrumbItemStructure';
import {INavigationHistoryType} from 'app/kbs/components/AddToKnowledgeBasePopover';
import {gt} from 'app/utils/i18n';

interface Props {
  hideNavigation?: boolean;
  navigationHistory: INavigationHistoryType[];
  handleGotoHistory: (index: number) => void;
  handleOneLevelup: () => void;
}

export const KBNavigationHistory = ({
  hideNavigation,
  navigationHistory,
  handleGotoHistory,
  handleOneLevelup,
}: Props) => {
  const doHandleGotoHistory = (
    event: React.MouseEvent<HTMLLinkElement, MouseEvent>,
    index: number
  ) => {
    event.preventDefault(); // prevent default breakcrumb behaviour
    handleGotoHistory(index);
  };
  return !hideNavigation ? (
    <>
      <nav aria-label="breadcrumb" className="px-2">
        <ol className="breadcrumb flex-nowrap mb-0 px-0">
          {navigationHistory.map((nav, index) => {
            const isActive = index + 1 == navigationHistory.length;
            return (
              <BreadcrumbItemStructure
                key={index}
                icon={nav.icon || 'fa-folder'}
                text={nav.text && isActive ? gt(`${nav.text}`) : ''}
                onClickItem={($event) => doHandleGotoHistory($event, index)}
                active={isActive}
                link={nav.link}
                shrinkText={true}
              />
            );
          })}
        </ol>
      </nav>

      {navigationHistory.length > 1 && (
        <StyledCompactItemHeaderSpan className="border-bottom">
          <button
            className="px-2 pb-2 d-block font-weight-bold text-dark btn px-0 py-2 flex-grow-1 d-flex align-items-center text-left btn-sm"
            onClick={handleOneLevelup}
          >
            <i className="fas fa-fw fa-level-up mr-1" />
            {gt('One level up...')}
          </button>
        </StyledCompactItemHeaderSpan>
      )}
    </>
  ) : null;
};
